import { Box, Button, TextField } from '@mui/material';
import { RoleFilterBlock } from "./RoleFilterBlock";
import AddIcon from '@mui/icons-material/Add';

export const FilteringBlock = ({ handleShowAdd, lngsltd, search, setSearch, roleFilter, setRoleFilter, handleClearFilters }) => {
    return (
        <Box display="flex" alignItems="center" gap={2} width="80%">
            <TextField
                size="small"
                fullWidth
                variant="outlined"
                placeholder={lngsltd["Search by Username"]}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />
            <RoleFilterBlock
                roleFilter={roleFilter}
                setRoleFilter={setRoleFilter}
                lngsltd={lngsltd} />

            <Button
                variant="outlined"
                color="error"
                fullWidth
                onClick={handleClearFilters}
            >
                {lngsltd["Clear Filters"]}
            </Button>

            <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => handleShowAdd()}
                startIcon={<AddIcon />}
            >
                {lngsltd["Add User"]}
            </Button>

        </Box>

    );
}

